module.exports = __webpack_public_path__ + "img/self1.42daa9e3.png";